module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pp-content pp-content--centered"
  }, [(_vm.$root.view == 'mobile') ? _c('div', {
    staticClass: "pp-mobile-back",
    on: {
      "click": function($event) {
        return _vm.$root.mobileBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-left"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pp-not-found"
  }, [_c('div', {
    staticClass: "pp-not-found__header"
  }, [_vm._v("\n            There doesn't seem to be anything here.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "pp-not-found__description"
  }, [_c('span', [_vm._v("You appear to have taken a wrong turn. Please use your browser's back button or ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/browse"
    }
  }, [_vm._v("start browsing.")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0beccdfd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/routes/NotFound.vue
// module id = 117
// module chunks = 0 1